<template>
  <div class="introduce">
    <div class="title">
      <h2 class="about">{{ introduce.title }}</h2>
      <span class="motto">
        {{ introduce.slogan }}
      </span>
    </div>
    <div class="info">
      <div class="describe">
        <p v-html="introduce.content"></p>
      </div>
      <img v-if="!video.url" :src="introduce.url" :alt="introduce.slogan" />
      <vueMiniPlayer
        v-else
        ref="vueMiniPlay"
        :video="video"
        :mutex="true"
        @fullscreen="handleFullscreen"
      ></vueMiniPlayer>
    </div>
  </div>
</template>

<script>
import HomeApi from '../../network/home'
import { program_type, content_type } from '../../common/enum/imgEnum'

export default {
  name: 'Introduce',
  data() {
    return {
      video: {
        url: '',
        cover: this.image,
        muted: false,
        loop: false,
        preload: 'auto',
        poster: '',
        volume: 1,
        autoplay: false
      },
      introduce: {}
    }
  },
  computed: {
    $video() {
      return this.$refs.vueMiniPlayer.$video
    }
  },
  async created() {
    await this._selectIntroduce()
  },
  methods: {
    /**
     * 搜索关于我们
     */
    async _selectIntroduce() {
      const result = await HomeApi.getContent(
        program_type.common,
        content_type.introduce
      )
      this.introduce = result.data[0]
    },
    newLine() {
      this.content = this.content.replace(/\n/g, '<br>')
    },

    handleFullscreen() {}
  }
}
</script>

<style scoped>
.introduce {
}

.title {
  text-align: center;
}

.about {
  font-weight: bolder;
  font-size: 40px;
  height: 20px;
  color: #ffffff;
}

.motto {
  padding-top: 20px;
  line-height: 80px;
  height: 80px;
  font-size: 20px;
  border-top: 1px solid #a9a9a9;
}

.info {
  margin-top: 60px;
  display: grid;
  grid-template-columns: 1fr 1fr;
}

.describe {
  display: flex;
  align-items: center;
  white-space: pre-wrap;
}

.describe > p {
  padding-right: 55px;
  word-spacing: 20px;
  line-height: 23px;
  font-weight: 550;
  text-align: justify;
  font-size: 14px;
}

.info > img {
  width: 100%;
}
</style>
